// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-6938b533] .el-form-item__content{line-height:20px!important;color:#606166;font-weight:400}div[data-v-6938b533] .el-form-item__label{padding-bottom:0!important;line-height:20px!important}.el-form-item[data-v-6938b533]{margin-bottom:5px!important}.el-tabs[data-v-6938b533]{width:400px;margin-bottom:10px}.tab-active[data-v-6938b533]{font-weight:700!important}", ""]);
// Exports
module.exports = exports;
